<div class="modal-body">
    <div class="row">
        <div class="col-md-12">
            <h1 class="text-center">{{product.name}}</h1>
            <article>
                <p>
                    <img
                        class="productImg"
                        [src]="product.imageUrl"
                    >
                </p>
                <div
                    *ngIf="product.listPrice > 0 && product.isPurchasable"
                    class="text-center"
                >
                    <app-product-price [product]="product"></app-product-price>
                </div>
                <div *ngIf="brandId === BrandEnum.CELPIP; else CAELproducts">
                    <div *ngIf="!hasNgCollapse; else ngCollapse">
                        <div [innerHTML]="product.description | safe: 'html'"></div>
                    </div>
                    <ng-template #ngCollapse>
                        <div [innerHTML]="nonCollapsibleDescription | safe: 'html'"></div>
                        <a
                            (click)="collapse.toggle()"
                            [attr.aria-expanded]="!isCollapsed"
                            aria-controls="collapseExample"
                        > Read more </a>
                        <div
                            class="mt-4"
                            #collapse="ngbCollapse"
                            [ngbCollapse]="isCollapsed"
                            [innerHTML]=" collapsibleDescription | safe: 'html'"
                        ></div>
                    </ng-template>
                </div>
                <ng-template #CAELproducts>
                    <div [innerHTML]="product.description | safe: 'html'"></div>
                </ng-template>
            </article>
            <br />
        </div>
        <div class="col-md-12">
            <div class="btn-toolbar pull-right">
                <div *ngIf="brandId === BrandEnum.CELPIP">
                    <button
                        type="button"
                        class="btn btn-primary m-1"
                        *ngIf="product.isPurchasable"
                        (click)="onAddItemToCart(product)"
                    >
                        <i class="fa fa-shopping-cart"></i>
                        Add to cart
                    </button>
                </div>
                <div *ngIf="brandId === BrandEnum.CAEL">
                    <button
                        type="button"
                        class="btn btn-primary m-1"
                        *ngIf="product.isPurchasable && (product.productTypeId !== electronicProductId || product.needsPurchase)"
                        (click)="onAddItemToCart(product)"
                    >
                        <i class="fa fa-shopping-cart"></i>
                        Add to Cart
                    </button>
                </div>
                <button
                    (click)="onContinue()"
                    type="button"
                    class="btn btn-primary m-1"
                >
                    Continue
                </button>
            </div>
        </div>
    </div>
</div>
